var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnectiaAppIcon = function SvgConnectiaAppIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320.59 320.59"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "connectia-app-icon_svg__a",
    x1: 266.56,
    x2: 164.13,
    y1: 197.09,
    y2: 197.09,
    "data-name": "Degradado sin nombre",
    gradientTransform: "matrix(1 0 0 -1 0 320.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb660a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#eb660a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#e3023a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#164389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0494d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4eafb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4eafb3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connectia-app-icon_svg__b",
    x1: 54.02,
    x2: 156.44,
    y1: 197.09,
    y2: 197.09,
    "data-name": "Degradado sin nombre 2",
    gradientTransform: "matrix(1 0 0 -1 0 320.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb660a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#eb660a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#e3023a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#164389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0494d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4eafb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4eafb3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connectia-app-icon_svg__c",
    x1: 154.23,
    x2: 133.45,
    y1: 98.92,
    y2: 98.92,
    "data-name": "Degradado sin nombre 3",
    gradientTransform: "matrix(1 0 0 -1 0 320.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb660a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#eb660a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#e3023a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#164389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0494d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4eafb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4eafb3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "connectia-app-icon_svg__d",
    x1: 109.84,
    x2: 130.62,
    y1: 98.92,
    y2: 98.92,
    "data-name": "Degradado sin nombre 4",
    gradientTransform: "matrix(1 0 0 -1 0 320.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eb660a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#eb660a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#e3023a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#164389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0494d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4eafb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4eafb3"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320.59,
    height: 320.59,
    fill: "#fff",
    rx: 69.31,
    ry: 69.31
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#connectia-app-icon_svg__a)",
    d: "M164.14 68.23h31.71v15.98a68 68 0 0 1 5.95-6.83c2.15-2.17 4.55-4.09 7.2-5.77s5.55-3 8.75-3.99a36.7 36.7 0 0 1 10.85-1.48c12.1 0 21.45 3.7 28.05 11.06 6.61 7.37 9.91 17.52 9.91 30.45v72.38h-31.7v-62.22c0-7.49-1.68-13.15-5.02-16.95-3.33-3.8-8.07-5.73-14.18-5.73s-10.95 1.91-14.5 5.73c-3.55 3.81-5.32 9.46-5.32 16.95v62.22h-31.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#connectia-app-icon_svg__b)",
    d: "M156.44 180.03h-31.7v-62.22c0-7.49-1.79-13.15-5.33-16.95-3.55-3.8-8.38-5.73-14.5-5.73s-10.85 1.91-14.18 5.73c-3.34 3.81-5 9.46-5 16.95v62.22h-31.7v-72.38q0-19.395 9.9-30.45c6.61-7.37 15.96-11.06 28.05-11.06 4.04 0 7.65.5 10.85 1.47 3.2.98 6.12 2.31 8.76 4a41.3 41.3 0 0 1 7.2 5.76 68 68 0 0 1 5.94 6.83V68.23h31.71z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#164389",
    d: "M69.2 233.3c-2.17 0-4.19-.4-6.05-1.18a15 15 0 0 1-4.82-3.23 15.43 15.43 0 0 1-4.31-10.8v-.08a15.48 15.48 0 0 1 4.31-10.8 14.7 14.7 0 0 1 4.86-3.3c1.9-.8 3.97-1.2 6.26-1.2 1.38 0 2.64.11 3.78.34s2.18.54 3.11.93c.93.4 1.8.87 2.58 1.44.8.56 1.52 1.18 2.2 1.86l-4.14 4.78c-1.16-1.04-2.33-1.86-3.53-2.45s-2.54-.89-4.04-.89a8.26 8.26 0 0 0-6.18 2.71 9.52 9.52 0 0 0-2.4 6.51v.08c0 1.27.2 2.47.62 3.6a9.5 9.5 0 0 0 1.75 2.95 8.1 8.1 0 0 0 6.2 2.75 9 9 0 0 0 4.3-.93 16.5 16.5 0 0 0 3.48-2.54l4.14 4.2a21 21 0 0 1-2.37 2.2 14.1 14.1 0 0 1-5.88 2.72c-1.16.24-2.45.36-3.89.36zm26.92 0q-2.625 0-4.86-.9c-2.235-.9-2.78-1.45-3.87-2.5a11.6 11.6 0 0 1-3.49-8.3v-.09a11.4 11.4 0 0 1 3.51-8.33 12.3 12.3 0 0 1 8.8-3.47c1.76 0 3.36.3 4.85.91s2.78 1.44 3.87 2.5a11.34 11.34 0 0 1 3.49 8.31v.07a11.38 11.38 0 0 1-3.5 8.33 12.3 12.3 0 0 1-8.8 3.47m.08-5.54c.93 0 1.75-.16 2.47-.49a5.47 5.47 0 0 0 3-3.3c.27-.75.4-1.54.4-2.39v-.08c0-.85-.14-1.64-.42-2.39a5.93 5.93 0 0 0-5.54-3.87 5.7 5.7 0 0 0-2.47.5 5.47 5.47 0 0 0-3 3.3c-.27.74-.4 1.53-.4 2.38v.08c0 .85.14 1.64.42 2.4s.7 1.4 1.23 1.98a5.8 5.8 0 0 0 4.31 1.88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#connectia-app-icon_svg__c)",
    d: "M133.45 210.13h6.43v3.24c.37-.48.77-.94 1.21-1.38s.92-.83 1.46-1.17a7.4 7.4 0 0 1 3.98-1.1c2.45 0 4.35.74 5.7 2.23 1.33 1.5 2 3.55 2 6.17v14.67h-6.43v-12.6c0-1.53-.34-2.67-1.02-3.45-.68-.77-1.63-1.16-2.87-1.16s-2.22.4-2.94 1.16-1.08 1.92-1.08 3.44v12.61h-6.43v-22.66Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#connectia-app-icon_svg__d)",
    d: "M130.61 232.8h-6.43v-12.62c0-1.52-.36-2.66-1.08-3.44-.72-.77-1.7-1.16-2.94-1.16s-2.2.4-2.87 1.16c-.68.77-1.02 1.92-1.02 3.44v12.61h-6.43v-14.67c0-2.62.67-4.68 2.01-6.17s3.23-2.24 5.7-2.24a7.46 7.46 0 0 1 3.97 1.11c.54.34 1.02.73 1.46 1.17s.84.9 1.21 1.38v-3.24h6.43v22.66Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#164389",
    d: "M167.23 233.3c-1.69 0-3.26-.28-4.7-.85a10.84 10.84 0 0 1-6.24-6.1 12.3 12.3 0 0 1-.89-4.77v-.08c0-1.6.27-3.13.82-4.57s1.32-2.69 2.3-3.76a10.85 10.85 0 0 1 8.07-3.47 10.1 10.1 0 0 1 8.35 3.74c.92 1.13 1.6 2.45 2.03 3.93s.66 3.02.66 4.63c0 .25 0 .52-.02.8 0 .28-.04.58-.06.9h-15.77c.31 1.46.95 2.56 1.92 3.31s2.18 1.12 3.61 1.12c1.07 0 2.03-.18 2.88-.55s1.72-.96 2.62-1.78l3.68 3.26c-1.07 1.33-2.37 2.36-3.89 3.11s-3.3 1.12-5.37 1.12zm4.14-13.6c-.2-1.45-.7-2.6-1.52-3.5s-1.9-1.33-3.26-1.33-2.45.44-3.28 1.31-1.37 2.04-1.63 3.51h9.69Zm20.49 13.6a11.85 11.85 0 0 1-8.45-3.45 11.63 11.63 0 0 1-3.34-8.26v-.08a11.93 11.93 0 0 1 3.34-8.33 11.4 11.4 0 0 1 3.74-2.54q2.175-.93 4.8-.93c2.14 0 3.92.34 5.33 1.01 1.41.68 2.65 1.61 3.72 2.8l-3.93 4.22a10.6 10.6 0 0 0-2.26-1.82 5.7 5.7 0 0 0-2.9-.68 4.9 4.9 0 0 0-2.22.5c-.66.31-1.24.76-1.73 1.32s-.87 1.22-1.14 1.97-.4 1.54-.4 2.4v.07c0 .87.13 1.7.4 2.45a5.5 5.5 0 0 0 5.35 3.81c1.07 0 2.01-.22 2.81-.66s1.6-1.02 2.4-1.75l3.75 3.8a14.4 14.4 0 0 1-3.76 2.98 11.4 11.4 0 0 1-5.5 1.16v.01Zm20.38-.12c-.99 0-1.88-.1-2.68-.32a4.75 4.75 0 0 1-2.07-1.12c-.58-.53-1.03-1.23-1.35-2.09s-.49-1.95-.49-3.28v-10.74h-2.7v-5.5h2.7v-5.79h6.43v5.8h5.33v5.5h-5.33v9.71c0 1.47.7 2.21 2.07 2.21 1.13 0 2.18-.28 3.17-.85v5.16a9.8 9.8 0 0 1-5.07 1.31Zm7.88-31.25h6.77v5.71h-6.77v-5.7Zm.17 8.2h6.43v22.66h-6.43zm28.18 29.51a19.03 19.03 0 0 1-13.48-5.43 18.14 18.14 0 0 1-5.37-13q0-3.81 1.44-7.17c1.44-3.36 2.27-4.2 3.93-5.88a18.7 18.7 0 0 1 5.88-4c2.26-.99 4.68-1.48 7.27-1.48s5.01.46 7.25 1.4a19.4 19.4 0 0 1 5.86 3.72c1.66 1.55 2.97 3.33 3.91 5.35s1.42 4.11 1.42 6.28q0 2.67-.66 4.65c-.66 1.98-1.04 2.43-1.8 3.32-.76.9-1.66 1.55-2.69 2s-2.12.64-3.28.64a9.04 9.04 0 0 1-4.12-.8 8 8 0 0 1-2.35-1.73c-.73.65-1.6 1.23-2.64 1.75s-2.23.78-3.6.78a8 8 0 0 1-3.03-.57 7.24 7.24 0 0 1-4.12-4.19c-.4-1-.59-2.13-.59-3.4a11.2 11.2 0 0 1 2.87-7.55c.87-.94 1.88-1.69 3.02-2.24s2.33-.82 3.57-.82c1.47 0 2.66.27 3.57.82a7.4 7.4 0 0 1 2.26 2.05l.46-2.24 5 .8-2 11.37c-.06.23-.09.46-.1.7l-.03.61c0 .76.27 1.4.8 1.9.53.51 1.3.76 2.28.76.76 0 1.46-.18 2.11-.55s1.21-.92 1.7-1.65.85-1.63 1.13-2.7c.28-1.08.42-2.32.42-3.73 0-1.94-.42-3.83-1.27-5.64s-2-3.42-3.49-4.82a17.22 17.22 0 0 0-11.9-4.59 16.57 16.57 0 0 0-15.48 10.3c-.85 2.03-1.27 4.21-1.27 6.52s.42 4.52 1.27 6.55 2.02 3.8 3.53 5.31 3.3 2.7 5.4 3.57c2.08.87 4.37 1.31 6.88 1.31 2.11 0 3.97-.24 5.56-.72s3.2-1.18 4.8-2.1l.85 1.34a23.4 23.4 0 0 1-5.18 2.33c-1.82.56-3.83.85-6.02.85zm-1.56-13.95c.68 0 1.32-.15 1.92-.46s1.14-.74 1.61-1.29.83-1.19 1.1-1.92.4-1.54.4-2.4a3.9 3.9 0 0 0-1.1-2.9 3.87 3.87 0 0 0-2.83-1.09c-.68 0-1.32.16-1.94.47a5.5 5.5 0 0 0-2.73 3.13c-.27.73-.4 1.52-.4 2.37 0 1.33.37 2.34 1.1 3.04s1.7 1.06 2.88 1.06ZM92.45 241.56h4.45c1.2 0 2.13.34 2.73.93.43.45.67 1 .67 1.67v.03c0 1.36-.84 2.06-1.66 2.42 1.24.37 2.24 1.1 2.24 2.52v.03c0 1.8-1.5 2.85-3.79 2.85h-4.64zm6.65 2.76c0-1.03-.82-1.7-2.3-1.7h-3.2v3.6h3.1c1.41 0 2.4-.64 2.4-1.87zm-2.19 2.94h-3.3v3.7h3.51c1.58 0 2.57-.7 2.57-1.88v-.03c0-1.13-.96-1.79-2.78-1.79m11.74-2.96h1.22l-3.24 7.96c-.66 1.6-1.4 2.18-2.57 2.18-.64 0-1.12-.13-1.64-.39l.4-.9c.36.18.71.27 1.2.27.7 0 1.12-.36 1.58-1.45l-3.5-7.68h1.26l2.81 6.43 2.48-6.43Zm7.03 6.2.73-.88c1.1 1 2.13 1.48 3.58 1.48s2.33-.75 2.33-1.78v-.03c0-.97-.52-1.52-2.72-1.99-2.4-.52-3.5-1.3-3.5-3v-.04c0-1.64 1.44-2.85 3.42-2.85 1.52 0 2.61.43 3.67 1.28l-.69.91a4.6 4.6 0 0 0-3-1.13c-1.37 0-2.23.75-2.23 1.7v.02c0 .98.54 1.54 2.83 2.03 2.33.51 3.4 1.36 3.4 2.96v.03c0 1.8-1.49 2.96-3.57 2.96a6.12 6.12 0 0 1-4.27-1.67zm13.87-9h1.1l4.76 10.51h-1.27l-1.22-2.76h-5.69l-1.24 2.76h-1.2l4.75-10.52h.01Zm2.91 6.67-2.37-5.3-2.39 5.3zm5.12-6.61h1.18v10.45h-1.18zm4.24 0h1.1l6.58 8.37v-8.37h1.15v10.45h-.94l-6.75-8.57v8.57h-1.15v-10.45zm14.55 1.09h-3.5v-1.09h8.2v1.1h-3.5V252h-1.2v-9.36Zm5.05 4.27h4.15v1.21h-4.15v-1.2Zm6.14-.11v-.03c0-2.87 2.1-5.4 5.24-5.4a5.5 5.5 0 0 1 3.9 1.4l-.77.9a4.45 4.45 0 0 0-3.18-1.2c-2.3 0-3.97 1.96-3.97 4.28v.03c0 2.5 1.6 4.34 4.13 4.34 1.2 0 2.3-.46 3.01-1.04v-2.6h-3.18v-1.06h4.31v4.16a6.3 6.3 0 0 1-4.19 1.6c-3.28 0-5.3-2.39-5.3-5.37Zm11.69 0v-.03c0-2.88 2.16-5.4 5.34-5.4a5.24 5.24 0 0 1 5.31 5.37v.03c0 2.88-2.16 5.4-5.34 5.4s-5.3-2.49-5.3-5.37Zm9.44 0v-.03c0-2.37-1.73-4.3-4.12-4.3s-4.09 1.9-4.09 4.27v.03c0 2.37 1.73 4.31 4.12 4.31s4.1-1.9 4.1-4.28Zm3.71-5.25h4.45c1.2 0 2.13.34 2.73.93.43.45.67 1 .67 1.67v.03c0 1.36-.84 2.06-1.66 2.42 1.24.37 2.24 1.1 2.24 2.52v.03c0 1.8-1.5 2.85-3.79 2.85h-4.64zm6.66 2.76c0-1.03-.82-1.7-2.3-1.7h-3.19v3.6h3.1c1.41 0 2.4-.64 2.4-1.87v-.03Zm-2.2 2.94h-3.3v3.7h3.51c1.58 0 2.57-.7 2.57-1.88v-.03c0-1.13-.96-1.79-2.78-1.79m10.18-5.76h1.1l4.76 10.5h-1.27l-1.22-2.76h-5.69l-1.24 2.76h-1.2l4.75-10.52h.01Zm2.91 6.67-2.37-5.3-2.39 5.3zm5.11-6.61h1.18v10.45h-1.18zm4.24 0h1.1l6.58 8.37v-8.37h1.15v10.45h-.94l-6.75-8.57v8.57h-1.15v-10.45z"
  })));
};
export default SvgConnectiaAppIcon;